






















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { composeDate, toDateString } from "@/utils/asesmenIntensifDateTime";

@Component({
  components: { VCDateTimePicker }
})
export default class AlatInvasifSection extends Vue {
  @Prop({ default: () => [] }) readonly value!: any[];
  @Prop({ default: false }) readonly disabled!: boolean;

  rows: any[] = [];

  created() {
    if (Array.isArray(this.value)) {
      this.rows = this.value.map(r => ({ ...r }));
    }
  }


  @Watch("rows", { deep: true })
  onRowsChange(val: any[]) { this.$emit("input", val.map(r => ({ ...r }))); }

  syncFromValue(val: any[]) {
    this.rows = Array.isArray(val) ? val.map(r => ({ ...r })) : [];
  }

  tanggalPasangDate(row: any): Date | null {
    return composeDate(row.tanggal_pasang);
  }

  setTanggalPasang(row: any, val: Date | null) {
    this.$set(row, "tanggal_pasang", toDateString(val));
  }

  addRow() {
    this.rows.push({ jenis_alat: "", ukuran: "", lokasi_pemasangan: "", tanggal_pasang: null });
  }

  removeRow(idx: number) {
    this.rows.splice(idx, 1);
  }
}
